import {Image} from '@codeurs/front'
import BizFfwdLogoWhite from 'assets/images/logos/bizffwd-logo-white.svg'
import DeeptechdiveLogoWhite from 'assets/images/logos/deeptechdive-logo-white.svg'
import FwddiveLogoWhite from 'assets/images/logos/fwddive-logo-white.svg'
import ItfbelgiumLogoWhite from 'assets/images/logos/itfbelgium-logo-white.svg'
import ItfFlandersLogoWhite from 'assets/images/logos/itfflanders-logo-white.svg'
import ItfWorldLogoWhite from 'assets/images/logos/itfworld-logo-white.svg'
import TinyaiLogoWhite from 'assets/images/logos/tinyai-logo-white.svg'
import React from 'react'
import {SubeventType} from 'types'
import {Link} from 'util/link'
import {ClassName, style} from 'util/style'

const styles = style('subeventlogo')

export const SubeventLogo: React.FC<{
	subevent: SubeventType
	url?: string
	className: ClassName
}> = ({subevent, url, ...props}) => {
	if (!subevent) return null

	const Tag = url ? Link : 'div'
	const attrs = url ? {to: url} : {}

	return (
		<Tag {...attrs} {...props} className={styles().mergeProps(props)}>
			{switchSubeventLogo(subevent)}
		</Tag>
	)

	function switchSubeventLogo(subeventLogo) {
		switch (subeventLogo) {
			case 'bizffwd':
				return (
					<Image {...BizFfwdLogoWhite} alt="Business Fast Forward (BIZ FFWD)" />
				)
			case 'deeptechdive':
				return <Image {...DeeptechdiveLogoWhite} alt="Deep Tech Dive" />
			case 'fwddive':
				return <Image {...FwddiveLogoWhite} alt="Forward Dive" />
			case 'itfbelgium':
				return <Image {...ItfbelgiumLogoWhite} alt="ITF Belgium" />
			case 'itfflanders':
				return <Image {...ItfFlandersLogoWhite} alt="ITF Flanders" />
			case 'itfworld':
				return <Image {...ItfWorldLogoWhite} alt="ITF World" />
			case 'tinyai':
				return <Image {...TinyaiLogoWhite} alt="Tiny AI" />
			default:
				return null
		}
	}
}
